/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット画面起動用JS
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import langJa from 'element-ui/lib/locale/lang/ja'
import langEn from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/icon.css'
import App from './App'
import axios from 'axios'
import WindowUtil from '@/utils/WindowUtil'
import FastchatStateManager from '@/utils/FastchatStateManager'
import MessageInfoConst from '@/constants/MessageInfoConst'
import VueVisible from 'vue-visible'

Vue.use(VueVisible)

Vue.config.productionTip = false
// Vue.config.devtools = true

Vue.use(Vuex)

Vue.use(vuexI18n.plugin, new Vuex.Store())
Vue.i18n.add('en', require('./assets/translations/translationsEn.json'))
Vue.i18n.add('ja', require('./assets/translations/translationsJa.json'))

axios.get('./json/extConfig.json').then(response => {
  const extConfig = {}
  const jsonData = response.data
  // extConfig.jsonより、要素を取得して、extconfigに格納
  if (jsonData) {
    for (let key1 in jsonData) {
      for (let key2 in jsonData[key1]) {
        extConfig['_' + key2] = jsonData[key1][key2]
      }
    }
  }
  Vue.prototype.$extConfig = extConfig
  axios.get('./service/findFastchatWindowSetting')
    .then((res) => {
      const configData = JSON.parse(res.data.fastchatWindowSettingJson)
      configData.serviceServer = configData.serviceServer || './service'
      configData.chatServer = configData.chatServer || '../../../chat/ws'
      configData.lang = configData.lang || 'ja'
      configData.parentOrigin = configData.parentOrigin || '*'
      configData.availableChatConnectionIntervalTime = configData.availableChatConnectionIntervalTime || 60000
      configData.fhMessageTypingLabelFadeoutTime = configData.fhMessageTypingLabelFadeoutTime || 6000
      configData.fcMessageTypingSendIntervalTime = configData.fcMessageTypingSendIntervalTime || 5000
      configData.webFormParentPath = res.data.webFormParentPath || '../../web'
      configData.webFormSettingId = res.data.webFormSettingId || null
      configData.surveyWindowConfig = configData.surveyWindowConfig || {
        useSurveyWindow: false
      }
      configData.surveyWindowConfig.surveyCommentTextMaxLength = configData.surveyWindowConfig.surveyCommentTextMaxLength || 2000
      configData.confirmMessage = configData.confirmMessage || {}
      configData.confirmMessage.answerList = configData.confirmMessage.answerList || [{
        id: 0,
        label: 'はい'
      }, {
        id: 1,
        label: 'いいえ'
      }]
      configData.switchConfirmMessage = configData.switchConfirmMessage || {}
      configData.switchConfirmMessage.answerList = configData.switchConfirmMessage.answerList || [{
        id: 0,
        label: 'はい',
        confirmType: MessageInfoConst.CONFIRM_TYPE_SWITCH_MANUAL,
        labelSynonym: ['はい', 'YES', 'Yes', 'yes', 'ok', '1'],
        waitChatReceive: true
      }, {
        id: 1,
        label: 'いいえ',
        confirmType: MessageInfoConst.CONFIRM_TYPE_SWITCH_MANUAL,
        labelSynonym: ['いいえ', 'NO', 'No', 'no', 'ng', '2']
      }]
      configData.suggestIntarval = configData.suggestIntarval || 1000

      if (WindowUtil.getQueryParamObject()['testMode'] === 'true') {
        configData._testMode = true
      }
      configData.sendImageFileFlg = configData.sendImageFileFlg || false
      configData.sendVideoFileFlg = configData.sendVideoFileFlg || false
      configData.sendFileFlg = configData.sendFileFlg || false
      configData.sendImageFileExtension = configData.sendImageFileExtension
      configData.sendVideoFileExtension = configData.sendVideoFileExtension
      configData.sendFileExtension = configData.sendFileExtension
      configData.sendFileMaxSize = configData.sendFileMaxSize || 2
      configData.sendFileNameMaxByteLength = configData.sendFileNameMaxByteLength || 512
      if (WindowUtil.getQueryParamObject()['mypage'] === '1') {
        configData['_myPageFlg'] = '1'
        FastchatStateManager.setDisableCloseBtnFlg()
        console.log('info:マイページフラグ有り')
      } else {
        configData['_myPageFlg'] = '0'
        FastchatStateManager.clearDisableCloseBtnFlg()
      }
      if (WindowUtil.getQueryParamObject()['nurofa2ak']) {
        configData['_nurofa2ak'] = WindowUtil.getQueryParamObject()['nurofa2ak'].substring(0, 64)
      }
      configData['_nuroChatAuthStatus'] = '0'

      const splitPath = location.href.split('/')
      configData['_fastchatWindowSettingId'] = Number(splitPath[splitPath.length - 2])
      Vue.use(require('vue-config'), configData)
      Vue.prototype.$config = configData

      // Set value of fastchat prob type list
      Vue.prototype.$extConfig['_fastChatProbTypeList'] = JSON.parse(res.data.fastChatProbTypeJson)

      // ロケール設定
      const lang = configData.lang
      // Element-ui部品のロケール設定
      if (lang === 'en') {
        locale.use(langEn)
      } else {
        locale.use(langJa)
      }
      // 翻訳メッセージのロケール設定
      Vue.i18n.set(lang)
      let isServiceAccess = false
      axios.get('./service/checkServiceAccess').then(_ => {
        isServiceAccess = true
      }).finally(_ => {
        // initializedFastchatFrame処理
        WindowUtil.addMessageEventListener('initializedFastchatFrame', function (event) {
          const supplementConfigData = event.data.supplementConfigData
          if (isServiceAccess && !FastchatStateManager.isAlwaysSeparateChatWindow()) {
            configData['_alwaysSeparateChatWindow'] = supplementConfigData['alwaysSeparateChatWindow']
          } else {
            configData['_alwaysSeparateChatWindow'] = true
          }
        }, true)
        // チャット画面起動
        /* eslint-disable no-new */
        new Vue({
          el: '#app',
          components: {
            App
          },
          template: '<App/>'
        })
        // フレーム初期化メッセージを送信
        WindowUtil.postInitFastchatFrameMessageToParent(configData.fastchatFrameConfig)
      })
    })
    .catch((res) => {
      console.error(res)
    })
})



// WEBPACK FOOTER //
// ./src/main.js